import { render, staticRenderFns } from "./Signature.vue?vue&type=template&id=0d49f4ca&scoped=true&"
import script from "./Signature.vue?vue&type=script&lang=js&"
export * from "./Signature.vue?vue&type=script&lang=js&"
import style0 from "./Signature.vue?vue&type=style&index=0&id=0d49f4ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d49f4ca",
  null
  
)

export default component.exports